<script setup>
import ModuleManagementPage from '@/components/roles/ModuleManagementPage.vue';
import { useSessionGuard } from '@/composables/useSessionGuard';

useSessionGuard();
</script>

<template>
  <ModuleManagementPage />
</template>
